module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "main"
    }
  }, [_c('el-row', _vm._l((_vm.menus), function(menu) {
    return _c('el-col', {
      key: menu.id,
      attrs: {
        "xs": 24,
        "sm": 12,
        "md": 6
      }
    }, [_c('div', {
      staticClass: "card"
    }, [_c('h4', [_c('img', {
      attrs: {
        "src": menu.ico
      }
    }), _c('br'), _vm._v(_vm._s(menu.menu))]), _vm._v(" "), _vm._l((menu.items), function(item) {
      return _c('el-col', {
        key: item.id,
        attrs: {
          "span": 12
        }
      }, [_c('router-link', {
        attrs: {
          "to": {
            path: item.path
          }
        }
      }, [_vm._v(_vm._s(item.name))])], 1)
    })], 2)])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a15bfc2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main.vue
// module id = 651
// module chunks = 1